'use client'

import { memo } from 'react'

const LANES = [
  { label: 'Recommended', title: 'NINX' },
  { label: 'Dictation', title: 'NINK' },
  { label: 'Mobile', title: 'Ningenie' },
] as const

/** Minimal post-hero beat: titles only, no cards or CTAs. */
export const NinPostHeroStart = memo(function NinPostHeroStart() {
  return (
    <section
      data-section="start"
      className="nin-post-hero-start relative z-20 py-24 md:py-32"
      aria-labelledby="nin-post-hero-start-heading"
    >
      <div className="mx-auto max-w-2xl px-6 text-center">
        <div className="ninxl-8bit-label ninxl-theme-text-accent mb-16 tracking-[0.25em]">
          START HERE
        </div>
        <h2 id="nin-post-hero-start-heading" className="sr-only">
          Start here: recommended, dictation, and mobile
        </h2>
        <ul className="m-0 flex list-none flex-col gap-20 p-0">
          {LANES.map((lane) => (
            <li key={lane.label} className="nin-post-hero-start__lane">
              <p className="ninxl-8bit-label ninxl-theme-text-muted mb-3 tracking-[0.2em]">
                {lane.label}
              </p>
              <p className="ninxl-8bit-heading ninxl-theme-text m-0 text-xl md:text-2xl">
                {lane.title}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
})